import AbstractApiModel from '@/models/abstracts/AbstractApiModel';
import doc from '@model-core/decorators/doc';
import type { Dayjs } from 'dayjs';
import { referenceOf } from '@/stores/useReferenceOptions';

/**
 * Signature d'une feuille d'heures (GET / POST /time_sheet_signatures) : qui (createdBy, URN de l'utilisateur) et
 * quand (createdAt), avec son image dessinée (FileModel). Signer fait avancer la feuille : l'employé la soumet, le Dirigeant la valide (signTimeSheet).
 * Une par signataire ; effacées au retour en brouillon après un refus. Filtres : timeSheet (ou liste d'IRI),
 * timeSheetSignatureType.
 */
export default class TimeSheetSignatureModel extends AbstractApiModel {
  protected _path = '/time_sheet_signatures/{?id}';

  declare _tsFilters: { timeSheet?: string | string[]; timeSheetSignatureType?: string };

  @doc.date declare createdAt: Dayjs;
  @doc.string declare createdBy: string;

  /** Son image dessinée se retrouve par cette URN (FileModel, source du fichier) */
  get urn(): string {
    return this.get<string, string>('@urn', `$:teiji:time_sheet_signature:${this.id}`);
  }

  /** timeSheet arrive en IRI ou imbriquée ({@id…}) */
  get timeSheetId(): number {
    const timeSheet = this.get<unknown, unknown>('timeSheet', null);
    const iri = typeof timeSheet === 'string' ? timeSheet : ((timeSheet as { '@id'?: string } | null)?.['@id'] ?? '');
    return Number(iri.split('/').pop()) || 0;
  }

  /** timeSheetSignatureType arrive en {id, reference, label} */
  get typeReference(): string {
    return (
      referenceOf('timeSheetSignatureTypes', this.get<unknown, unknown>('timeSheetSignatureType', null))?.reference ??
      ''
    );
  }
}
